<template>
  <div class="share-pay">
<!--    <ul>-->
<!--      <li-->
<!--        :class="item===liLink?'li-sty li-check':'li-sty'"-->
<!--        v-for="(item,index) in liData"-->
<!--        :key="index"-->
<!--        @click="checkLi(item)"-->
<!--      >{{item}}</li>-->
<!--    </ul>-->
<!--    <div v-if="liLink==='缴费'" class="pay-div">-->
<!--      <van-field required label="项目：" :border="false">-->
<!--        <template #input>-->
<!--          <van-dropdown-menu>-->
<!--            <van-dropdown-item-->
<!--              @change="changeProject"-->
<!--              v-model="formData.project"-->
<!--              :options="project"-->
<!--            />-->
<!--          </van-dropdown-menu>-->
<!--        </template>-->
<!--      </van-field>-->
<!--      <van-field required label="缴费方式：" :border="false">-->
<!--        <template #input>-->
<!--          <van-dropdown-menu>-->
<!--            <van-dropdown-item v-model="formData.priceId" :options="pay" />-->
<!--          </van-dropdown-menu>-->
<!--        </template>-->
<!--      </van-field>-->
<!--      <van-field required label="*租赁电脑个数(50元/个/月)：" :border="false">-->
<!--        <template #input>-->
<!--          <van-dropdown-menu>-->
<!--            <van-dropdown-item v-model="formData.computerNum" :options="number" />-->
<!--          </van-dropdown-menu>-->
<!--        </template>-->
<!--      </van-field>-->
<!--      <van-field-->
<!--        required-->
<!--        readonly-->
<!--        clickable-->
<!--        name="calendar"-->
<!--        :value="formData.startDate"-->
<!--        label="计费开始日期："-->
<!--        placeholder="点击选择日期"-->
<!--        @click="showCalendar = true"-->
<!--        :border="false"-->
<!--      >-->
<!--        <template #button>-->
<!--          <img class="img" src="./img/calendar.png" alt />-->
<!--        </template>-->
<!--      </van-field>-->
<!--      <van-calendar v-model="showCalendar" :show-confirm="false" @confirm="onConfirm" />-->
<!--      <van-field-->
<!--        v-model="formData.seatNo"-->
<!--        :border="false"-->
<!--        required-->
<!--        label="座位号："-->
<!--        placeholder="请选择"-->
<!--      >-->
<!--        <template #button>-->
<!--          <img @click="checkBut" class="img2" src="./img/choice.png" alt />-->
<!--        </template>-->
<!--      </van-field>-->
<!--      <div class="button">-->
<!--        <div class="cancel" @click="cancel"></div>-->
<!--        <div class="submit" @click="onSubmit"></div>-->
<!--      </div>-->
<!--    </div>-->
    <pay-record v-if="liLink==='共享办公缴费记录'"></pay-record>
    <van-popup v-model="showSeat">
      <choose-seat :show="showSeat" @getSeatNum="getSeatNum"></choose-seat>
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/kingWaiter";
import payRecord from './payRecord.vue';
import chooseSeat from './chooseSeat.vue';
import { UrlSearch } from "@/utils/utils";
import { Toast } from 'vant';
import { Dialog } from 'vant'
export default {
  components: { payRecord, chooseSeat },
  data() {
    return {
      liData: ['共享办公缴费记录'],
      liLink: '共享办公缴费记录',
      formData: {
        project: 1,
        priceId: null,
        computerNum: 0,
        startDate: this.formatDate(new Date()),
        seatId: null,
        seatNo: null,
        phoneNo: ''
      },
      project: [
        { text: '独立工位', value: 1 },
        { text: '包间位', value: 2 },
      ],
      pay: [],
      number: [
        { text: '0', value: 0 },
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5', value: 5 },
        { text: '6', value: 6 },
        { text: '7', value: 7 },
        { text: '8', value: 8 },
        { text: '9', value: 9 },
        { text: '10', value: 10 },
        { text: '11', value: 11 },
        { text: '12', value: 12 },
      ],
      showCalendar: false,
      showSeat: false,


    }
  },
  mounted() {
    this.changeProject(this.formData.project)
    // this.init()
  },
  methods: {
    formatDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month: month;
      let day = date.getDate();
      day = day < 10 ? '0' + day: day;
      return `${year}-${month}-${day}`;
    },
    //日历选择
    onConfirm(date) {
      this.formData.startDate = this.formatDate(date);
      this.showCalendar = false;
    },
    init() {
      if (UrlSearch().liLink) {
        this.checkLi('缴费记录');
      }
    },
    checkLi(item) {
      this.liLink = item
    },
    // 缴费方式
    changeProject(value) {
      this.pay = []
      let data = {
        seatType: value || this.formData.project
      }
      this.$fetchGet(URL.payType.url, data).then(res => {
        if (res.data.code === 20000) {
          let list = res.data.data
          for (let i = 0; i < list.length; i++) {
            let p = {}
            p.text = list[i].payName
            p.value = list[i].id
            this.pay.push(p)
          }
          let that = this
          that.formData.priceId = that.pay[0].value
        }
      })
    },
    getSeatNum(data) {
      console.log(data, '11');
      this.showSeat = false
      this.formData.seatNo = data.seatNo
      this.formData.seatId = data.id
    },
    //弹出选座界面
    checkBut() {
      this.showSeat = true
    },
    cancel() {
      //跳转到
      this.$router.push('/mine')
    },
    onSubmit(){
      let phone = localStorage.getItem("phone")
      if (!phone) {
        Dialog.confirm({
          title: '系统提示',
          message: '您还未认证，请先实名认证！',
        }).then(() => {
          this.$router.push('/audit')
        })
      }
      this.formData.phoneNo = phone
      if(this.formData.project===''){
        Toast('请选择项目')
      }else if(this.formData.priceId==null){
        Toast('请选择缴费方式')
      }else if(this.formData.startDate==null){
        Toast('请选择计费开始日期')
      }else if(this.formData.seatNo==null || this.formData.seatNo==''){
        Toast('请选择座位号')
      }
      this.$fetchPost(URL.sumSeat.url, this.formData).then(res => {
        if (res.data.code === 20000) {
          let info = res.data.data
          Dialog.confirm({
            title: '系统提示',
            message: '是否确认支付【' + info.amount + '】元？',
          }).then(() => {
            this.$fetchPost(URL.confirmPay.url, info).then(res => {
              if (res.data.code === 20000) {
                Toast('支付成功')
              } else {
                Toast('支付失败')
              }
            })
          })
        } else {
          Toast(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.share-pay {
  height: 100vh;
  background: #ffffff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  ul {
    display: flex;
    justify-content: space-between;
    .li-sty {
      width: 188px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      background: url("./img/li.png") no-repeat 100%;
      background-size: 100% 100%;
    }
    .li-check {
      font-weight: 500;
      color: #ffffff;
      background: url("./img/li1.png") no-repeat 100%;
      background-size: 100% 100%;
    }
  }
  .pay-div {
    margin-top: 30px;
    /deep/ .van-cell {
      width: 95%;
      margin: 5px auto auto auto;
      .van-field__label {
        width: 99px;
        font-size: 12px;
        letter-spacing: 1px;
      }
      .van-field__value {
        width: 206px;
        height: 23px;
        padding: 0 10px;
        background-color: #fffdfa;
        border: 1px solid rgba(255, 215, 195, 0.5);
        img {
          display: block;
        }
        .img {
          width: 11px;
          height: 14px;
        }
        .img2 {
          width: 39px;
          height: 15px;
        }
      }
    }
    /deep/ .van-dropdown-menu {
      width: 100%;
      .van-cell__title,
      .van-cell__value {
        flex: inherit;
        .van-dropdown-item__icon {
          margin-left: 30px;
        }
      }
      .van-dropdown-menu__bar {
        height: auto;
        box-shadow: none;
        background: transparent;
        .van-dropdown-menu__title {
          width: 100%;
          padding: 0;
          .van-ellipsis {
            font-size: 11px;
          }
        }
        .van-dropdown-menu__title::after {
          right: 0;
          border-color: transparent transparent #999999 #999999;
        }
      }
    }
    .button {
      display: flex;
      justify-content: center;
      margin-top: 200px;
      .cancel,
      .submit {
        width: 100px;
        height: 30px;
      }
      .cancel {
        background: url("./img/cancel.png") no-repeat 100%;
        background-size: 100% 100%;
      }
      .submit {
        margin-left: 30px;
        background: url("./img/submit.png") no-repeat 100%;
        background-size: 100% 100%;
      }
    }
  }
}
</style>